module.exports = __webpack_public_path__ + "static/media/02-banner-05-santa-fe-mobile@2x.e25567a9.jpg";